import React from 'react'
import TopHeader from '../home/TopHeader'
import Breadcrumbs from '../common/Breadcrumbs'
import Footer from '../home/Footer'

export default function Terms() {
    return (
        <div>
            <TopHeader />
            <Breadcrumbs main={"Terms and Conditions"} parent={"Terms and Conditions"} />
            <div className="container">
                <h4>Welcome to H N Store</h4>
                <p>
                    These Terms and Conditions (“Terms”) govern your use of the H N Store
                    website (<a href="https://www.hnstore.co.in" target="_blank" rel="noopener noreferrer">
                        www.hnstore.co.in</a>) and the services we provide through it.
                    By accessing or using our website, you agree to comply with these Terms.
                    If you do not agree, please refrain from using our site.
                </p>

                <h4>Business Nature</h4>
                <p>
                    H N Store operates as a supplier offering products for both B2B and B2C customers.
                    The website allows you to browse products, add items to your cart, and complete purchases securely
                    through our integrated <strong>payment gateway</strong>.
                    All transactions made through the website are subject to these Terms.
                </p>

                <h4>Eligibility</h4>
                <p>
                    By using our website, you confirm that you are at least 18 years old and have the legal capacity
                    to enter into binding contracts. If you are acting on behalf of a business or organization,
                    you represent that you have the authority to bind that entity.
                </p>

                <h4>Use of Website</h4>
                <p>You agree to use our website only for lawful purposes. You must not:</p>
                <ul>
                    <li>Submit false, misleading, or fraudulent information.</li>
                    <li>Attempt to gain unauthorized access to our systems.</li>
                    <li>Upload or transmit harmful code, viruses, or malicious software.</li>
                    <li>Interfere with the operation, security, or functionality of the site.</li>
                    <li>Use our content, trademarks, or materials without written permission.</li>
                </ul>

                <h4>Orders and Payments</h4>
                <p>
                    By placing an order on H N Store, you agree to provide accurate information for processing and delivery.
                    All prices displayed are in the applicable currency and are inclusive/exclusive of taxes as specified.
                </p>
                <p>
                    Payments are processed securely through a trusted <strong>payment gateway</strong>.
                    We do not store your credit or debit card details on our servers.
                    Once your payment is successfully processed, you will receive an order confirmation by email.
                </p>

                <h4>Refunds and Cancellations</h4>
                <p>
                    Refunds and cancellations are subject to our <a href="/refund-policy" className="text-main-600">Refund & Cancellation Policy</a>.
                    H N Store reserves the right to cancel or refuse any order at its sole discretion, including but not limited to
                    cases of inaccurate pricing, product unavailability, or suspected fraudulent transactions.
                </p>

                <h4>Shipping and Delivery</h4>
                <p>
                    Delivery timelines are provided at checkout and may vary based on location and product availability.
                    While we make every effort to deliver on time, delays may occur due to external factors
                    beyond our control. Risk of loss and title for products pass to you upon delivery.
                </p>

                <h4>Privacy</h4>
                <p>
                    Your use of our website and any personal information you provide is subject to our
                    <a href="/privacy-policy" className="text-main-600"> Privacy Policy</a>,
                    which outlines how we collect, use, and protect your data, including payment information.
                </p>

                <h4>Intellectual Property</h4>
                <p>
                    All text, images, graphics, logos, and other content displayed on our website
                    are the property of H N Store or its partners. You may not copy,
                    reproduce, or distribute our content without prior written consent.
                </p>

                <h4>Limitation of Liability</h4>
                <p>
                    H N Store is not responsible for any indirect, incidental, or consequential
                    damages arising from your use of the website. While we make reasonable efforts to ensure
                    the accuracy of the information provided, product specifications, pricing, and availability
                    are subject to change without notice.
                </p>

                <h4>Third-Party Links</h4>
                <p>
                    Our website may contain links to third-party websites for convenience.
                    We are not responsible for the content, policies, or practices of these external sites.
                </p>

                <h4>Changes to Terms</h4>
                <p>
                    We may update these Terms from time to time. Any changes will be posted on this page,
                    and your continued use of the website after such updates constitutes your acceptance of the new Terms.
                </p>

                <h4>Contact Information</h4>
                <p>
                    For questions regarding these Terms and Conditions, please contact us: <br />
                    <strong>Email:</strong> <a href="mailto:hnstoreuser@gmail.com">hnstoreuser@gmail.com</a><br />
                </p>
            </div>
            <Footer />
        </div>
    )
}
